/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/ChallengeAuthorities/ClearRowsDailyPyramidAuthority',[
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/PyramidLogic/IDailyPyramidAuthority'
], function (IDailyAuthority, ChallengeConstants, IDailyPyramidAuthority) {
    "use strict";


    var ClearRowsDailyPyramidAuthority = function (param) {
        this.initClearRowsDailyPyramidAuthority(param);
    };

    var Key_RowsRequired = "ROWSREQUIRED";

    ClearRowsDailyPyramidAuthority.constructor = ClearRowsDailyPyramidAuthority;
    ClearRowsDailyPyramidAuthority.prototype = Object.create(IDailyPyramidAuthority.prototype);

    ClearRowsDailyPyramidAuthority.prototype.initClearRowsDailyPyramidAuthority = function (param) {
        IDailyPyramidAuthority.call(this, param);

        this.SuppressBonusAnimations = true;

        var isDirty = true;
        if (param != null && param[Key_RowsRequired])
        {
            this.RowsRequired = parseInt(param[Key_RowsRequired]);
            isDirty = isNaN(this.BoardsToClear);
        }

        if (isDirty)
            throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.ClearRows;
    };


    ClearRowsDailyPyramidAuthority.prototype.IsGameWon = function () {
        if (this.CardSupply.IsWaitingForAds)
        {
            return false;
        }

        return (!this.CardSupply.WaitingForAnimation) && this.RowsCleared >= this.RowsRequired;
    };

    return ClearRowsDailyPyramidAuthority;

});
